/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentPlaylistNavigation.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/transitional/components/View';
import ACNavigatorButton from 'academy-common-lib/components/navigation/contentNavigator/ACNavigatorButton';
import ACVerticalStepper from 'academy-common-lib/components/progress/ACVerticalStepper';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LearningPageSidebar from '../../../containers/TrackPage/LearningPageSidebar.migrated';
import { NextPlaylistContent } from '../../playlistContent/components/NextPlaylistContent.migrated';
import { getHumanizedDuration } from '../../../utils/utils.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentPlaylistNavigation.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const ShortContentPlaylistNavigation = ({
  short: {
    id,
    name,
    duration,
    progress
  }
}) => {
  const {
    isTablet
  } = useMediaQuery();
  if (isTablet) return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        title,
        subtitle,
        url,
        showPlaylistNavigatorCta
      }) => showPlaylistNavigatorCta ? /*#__PURE__*/_jsx(ACNavigatorButton, {
        active: false,
        helpText: subtitle,
        title: title,
        to: url
      }) : null,
      shortId: id
    })
  });
  return /*#__PURE__*/_jsxs(LearningPageSidebar, {
    backgroundColor: "fill-surface-default",
    id: "sidebarNavigator",
    withSubNav: 1,
    children: [/*#__PURE__*/_jsx(ACVerticalStepper, {
      activeStep: 0,
      iconOffset: "300",
      renderStep: step => /*#__PURE__*/_jsxs(View, {
        paddingBlock: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h6",
          children: step.title
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: getHumanizedDuration(step.duration)
        })]
      }),
      stepSpacing: {
        padding: '400'
      },
      steps: [{
        title: name,
        duration,
        complete: (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED'
      }]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        title,
        subtitle,
        url,
        showPlaylistNavigatorCta
      }) => showPlaylistNavigatorCta ? /*#__PURE__*/_jsx(ACNavigatorButton, {
        active: false,
        helpText: subtitle,
        title: title,
        to: url
      }) : null,
      shortId: id
    })]
  });
};